import { Flex, Spinner, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { fetchPresignedMasterDataUrl } from 'src/api/fetch';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { Database, Download } from 'lucide-react';
import { useFilterContext } from 'src/contexts/FilterContext';
import { MenuOpenerButton } from 'src/components/atoms/MenuOpenerButton';

export const MasterDataDownloadButton: React.FC = () => {
  const { currentModelVersion } = useFilterContext();

  const [isDownloading, setIsDownloading] = useState(false);

  if (!currentModelVersion?.masterDataAvailable) {
    return null;
  }

  const onDownloadClick = async () => {
    if (isDownloading) {
      return;
    }

    setIsDownloading(true);

    try {
      const presignedUrl = await fetchPresignedMasterDataUrl({
        customer: currentModelVersion.customerName,
        model_build: currentModelVersion.buildID,
        model_id: currentModelVersion.modelID,
      });

      window.location.href = presignedUrl;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <MenuOpenerButton>
      <Flex
        alignItems="center"
        cursor="pointer"
        onClick={onDownloadClick}
        title="Download Master Data"
        fontSize="md"
        color="content.title">
        {isDownloading ? (
          <Spinner size="sm" mr="3" />
        ) : (
          <ChakraIcon as={Database} boxSize={5} mr="3" verticalAlign="middle" />
        )}
        <Text>Master Data</Text>
        <ChakraIcon as={Download} boxSize={5} ml="3" verticalAlign="middle" />
      </Flex>
    </MenuOpenerButton>
  );
};
